import React from 'react';

const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15">
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M13.746 13.433l-2.886-3.05c.812-1.092 1.3-2.464 1.3-3.957C12.16 2.883 9.433 0 6.08 0 2.729 0 0 2.883 0 6.426c0 3.542 2.886 6.203 6.239 6.203 1.313 0 2.37-.225 3.365-.977l2.913 3.079c.17.179.392.269.615.269.222 0 .444-.09.614-.27.339-.357.339-.938 0-1.297zM1.736 6.426c0-2.53 1.95-4.59 4.345-4.59 2.394 0 4.342 2.06 4.342 4.59s-1.79 4.625-4.184 4.625c-2.395 0-4.502-2.094-4.502-4.625z"
    />
  </svg>
);

export default SearchIcon;



// WEBPACK FOOTER //
// ./src/components/search/searchbar/SearchIcon.jsx